import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { ConversationSettings } from '../Conversation';
import type { TConversationListFilter } from '../../constants/conversationStatus';

export const Header = ({
    listFilter,
    onListFilterChange,
    tagsView,
    onViewChange,
    availableAreas = [],
    selectedArea = '',
    onAreaFilterChange,
}: {
    listFilter: TConversationListFilter;
    onListFilterChange: (filter: TConversationListFilter) => void;
    tagsView: 'none' | 'labels' | 'badges';
    onViewChange: (view: 'none' | 'labels' | 'badges') => void;
    availableAreas?: string[];
    selectedArea?: string;
    onAreaFilterChange?: (area: string) => void;
}) => {
    return (
        <Box
            style={{
                padding: '10px 10px 5px 10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <Typography
                variant="h3"
                style={{
                    fontSize: 18,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                Conversaciones
            </Typography>
            <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                <ConversationSettings
                    listFilter={listFilter}
                    onListFilterChange={onListFilterChange}
                    tagsView={tagsView}
                    onViewChange={onViewChange}
                    availableAreas={availableAreas}
                    selectedArea={selectedArea}
                    onAreaFilterChange={onAreaFilterChange}
                />
            </Box>
        </Box>
    );
};
